var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trivia-count"},[_c('p',[_vm._v(_vm._s(_vm.current)+"/"+_vm._s(_vm.total))])])}
var staticRenderFns = []

export { render, staticRenderFns }